
  var _styles = {
  "free-card-fail-container": {
    "width": "7.52rem",
    "height": "6.82667rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative",
    "overflow": "hidden"
  },
  "free-card-fail-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "2.12rem"
  },
  "free-card-fail-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.82667rem",
    "textAlign": "center"
  },
  "free-card-fail-desc": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "textAlign": "center",
    "marginTop": "0.09333rem"
  },
  "free-card-fail-close-btn": {
    "marginTop": "1.53333rem"
  }
};



  module.exports = _styles;
  